import ReactGA from 'react-ga';

const replaceGUIDWithGeneric = url => {
  return url.replace(
    /([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/,
    '<id>'
  );
};

window.addEventListener('load', () => {
  const trackingId =
    (window.GOOGLE_TRACKING_ID || '').indexOf('UA') === 0
      ? window.GOOGLE_TRACKING_ID
      : 'UA-54753018-4';
  ReactGA.initialize(trackingId);
  ReactGA.pageview(replaceGUIDWithGeneric(window.location.pathname));
});



// WEBPACK FOOTER //
// ./src/tracking.js